import { frontendURL } from 'dashboard/helper/URLHelper';

const HrDashboardIndex = () => import('./pages/HrDashboardIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/hr-dashboard'),
      name: 'hr_dashboard_index',
      component: HrDashboardIndex,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
